import createLucideIcon from '../createLucideIcon';

const Battery = createLucideIcon('Battery', [
  [
    'rect',
    {
      width: '16',
      height: '10',
      x: '2',
      y: '7',
      rx: '2',
      ry: '2',
      key: '1w10f2',
    },
  ],
  ['line', { x1: '22', x2: '22', y1: '11', y2: '13', key: '4dh1rd' }],
]);

export default Battery;
